import { StructCapDealType } from '../../../enums/struct-cap-crm-deal-type.enum';
import { StructCapCRMStatus } from '../../../enums/struct-cap-crm-status';
import { CompanyStage } from '../../../enums/company-stage.enum';
import { HealthcareSubSector } from '../../../enums/healthcare-sub-sector.enum';
import { StructCapCrmDealSourceType } from '../../../enums/struct-cap-crm-deal-source-type.enum';
import { BaseCRMItem } from '../CRMItem.model';
import { User } from '../../user.model';
import { StructCapCrmStatusReason } from '../../../enums/struct-cap-crm-status-reason';

export class StructCapCRMItem extends BaseCRMItem {
  capIqId: number;
  status: StructCapCRMStatus;
  totalDealSize: number;
  raDealSize: number;
  priority: number;
  dealSourceContact: string;
  companyStage: CompanyStage;
  healthcareSubSector: HealthcareSubSector;
  diseaseFocus: string;
  location: string;
  expectedClosingDate: Date | string;
  revenueModel: string;
  downsideSupport: string;
  ltmRevenue: number;
  ltmEbitda: number;
  expectedIrr: number;
  expectedMoic: number;
  lastRoundValuation: number;
  currentRoundValuation: number;
  ndaSigned: boolean;
  ndaExpiration: Date | string;
  dealTypes: Array<StructCapDealType>;
  dealSourceType: StructCapCrmDealSourceType;
  dealSourceTypeFreeText: string;
  sourceUsers: Array<User>;
  summary: string;
  statusReason: StructCapCrmStatusReason;
  nextSteps: string;
  nonDeal: boolean;
}
